import { useTheme } from '@mui/material';
import { useEffect, useState } from 'react';

import InspectifyLogoSvg from '@inspectify/design/assets/brands/inspectify/InspectifyLogoColor.svg';
import InspectifyLogoWhiteSvg from '@inspectify/design/assets/brands/inspectify/InspectifyLogoWhite.svg';
import BetterLogoSvg from '@inspectify/design/assets/brands/white-labelling/BetterInspect.svg';
import HomeRiverGroupLogoSvg from '@inspectify/design/assets/brands/white-labelling/HomeRiverGroup.svg';
import SectorCapitalLogoSvg from '@inspectify/design/assets/brands/white-labelling/SectorCapital.svg';
import HomesteadLogoPng from '@inspectify/design/assets/brands/white-labelling/homesteadinspectify.png';
import HomesteadLogoLightPng from '@inspectify/design/assets/brands/white-labelling/homesteadinspectifyLight.png';
import { selectOrder } from '../redux/slices/reportSlice/report';
import { useAppSelector } from '../redux/store';

type WhiteLabellingData = {
  enabled: boolean;
  displayName: string;
  logoUrl: string;
  logoLightUrl: string;
  email: string;
  phoneNumber: string;
  phoneNumberLink: string;
  formattedPhoneNumber: string;
  showPoweredByInspectify: boolean;
};

const sectorCapitalWhiteLabellingData: WhiteLabellingData = {
  enabled: true,
  logoUrl: SectorCapitalLogoSvg,
  logoLightUrl: SectorCapitalLogoSvg,
  displayName: 'Sector Capital',
  email: 'office@sectorcapital.us',
  phoneNumber: '3034444022',
  phoneNumberLink: 'tel:303-444-4022',
  formattedPhoneNumber: '1 (303) 444-4022',
  showPoweredByInspectify: true,
}

const betterInspectWhiteLabellingData: WhiteLabellingData = {
  enabled: true,
  displayName: 'Better Inspect',
  logoUrl: BetterLogoSvg,
  logoLightUrl: BetterLogoSvg,
  email: 'betterinspect@inspectify.com',
  phoneNumber: '8552716922',
  phoneNumberLink: 'tel:855-271-6922',
  formattedPhoneNumber: '1 (855) 271-6922',
  showPoweredByInspectify: true,
};

const hrgWhiteLabellingData: WhiteLabellingData = {
  enabled: true,
  displayName: 'Home River Group',
  logoUrl: HomeRiverGroupLogoSvg,
  logoLightUrl: HomeRiverGroupLogoSvg,
  email: 'fieldreports@homeriver.com',
  phoneNumber: '8884481748',
  phoneNumberLink: 'tel:888-448-1748',
  formattedPhoneNumber: '1 (888) 448-1748',
  showPoweredByInspectify: true,
};

const homesteadWhiteLabellingData: WhiteLabellingData = {
  enabled: true,
  displayName: 'Homestead Inspection Service',
  logoUrl: HomesteadLogoPng,
  logoLightUrl: HomesteadLogoLightPng,
  email: 'homestead@inspectify.pro',
  phoneNumber: '7814006544',
  phoneNumberLink: 'tel:781-400-6544',
  formattedPhoneNumber: '1 (781) 400-6544',
  showPoweredByInspectify: false,
};

const whiteLabellingMap: {[companyId: string]: WhiteLabellingData} = {
  '281': betterInspectWhiteLabellingData,
  '1575': hrgWhiteLabellingData,
  '3723': sectorCapitalWhiteLabellingData,
  '3796': homesteadWhiteLabellingData,
};

export const useWhiteLabelling = () => {
  const theme = useTheme();
  const order = useAppSelector(selectOrder)

  const [whiteLabellingData, setWhiteLabellingData] = useState<WhiteLabellingData>({
    enabled: false,
    displayName: 'Inspectify',
    logoUrl: theme.palette.mode === 'dark' ? InspectifyLogoWhiteSvg : InspectifyLogoSvg,
    logoLightUrl: InspectifyLogoWhiteSvg,
    email: 'hello@inspectify.com',
    phoneNumber: '8552716876',
    phoneNumberLink: 'tel:855-271-6876',
    formattedPhoneNumber: '1 (855) 271-6876',
    showPoweredByInspectify: false,
  });

  useEffect(() => {
    if (!order?.team?.companyId) return;

    if (whiteLabellingMap[order.team.companyId]) {
      setWhiteLabellingData(whiteLabellingMap[order.team.companyId]);
    }
  }, [order, setWhiteLabellingData]);

  return whiteLabellingData;
};
